module.exports = __webpack_public_path__ + "img/face68.8b26521b.gif";